/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SendEmailCodeDto } from '../../models/send-email-code-dto';

export interface UserClientControllerSendEmailCodeV1$Params {
      body: SendEmailCodeDto
}

export function userClientControllerSendEmailCodeV1(http: HttpClient, rootUrl: string, params: UserClientControllerSendEmailCodeV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'token'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, userClientControllerSendEmailCodeV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'token'?: string;
      }>;
    })
  );
}

userClientControllerSendEmailCodeV1.PATH = '/api/v1/users/client/email/code';
